export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-medium-46fdf4bec235a7e6de6550e124ea0cd6.svg";